import React, { useState } from 'react';

import lang from '../../lib/language';

import IconAlert from '../../assets/img/warning-icon.svg';
import { useIsMobile } from '../../hooks';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import { BaseModal, MobileDrawer } from '../index';

import styles from './ShortSellOrderPlace.module.scss';

type Props = {
  processModal: () => void;
  toggleModal: () => void;
}

const ShortSellOrderPlace = ({ toggleModal, processModal }: Props) => {
  const { isMobile } = useIsMobile();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleClose = () => setIsOpen(false);

  const renderContent = () => (
    <>
      <div className={styles.text}>
        {lang.commonTradingShortSellDialogDescription()}
      </div>
      <div className={styles.timeAlert}>
        <img className={styles.reportsIcon} src={IconAlert} alt="short sell open hours alert" />
        <span className={styles.info}>{lang.commonTradingShortSellDialogDescriptionWeb()}</span>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          fullWidth
          biggerFontSize
          onClick={processModal}
        >
          {lang.commonOkay()}
        </Button>
        <Button
          variant={ButtonTypesEnum.Secondary}
          fullWidth
          biggerFontSize
          onClick={handleClose}
        >
          {lang.commonCancelMultiple()}
        </Button>
      </div>
    </>
  );
  if (isMobile) {
    return (
      <MobileDrawer title={lang.commonTradingShortSellDialog()} isOpen={isOpen} onClose={toggleModal}>
        {renderContent()}
      </MobileDrawer>
    );
  }
  return (
    <BaseModal isOpen={isOpen} toggle={toggleModal}>
      <div className={styles.title}>{lang.commonTradingShortSellDialog()}</div>
      {renderContent()}
    </BaseModal>
  );
};
export default ShortSellOrderPlace;
